<header>
  <div class="logo">
    <a link="/" uiLink>
      <img alt="Lekkerland logo" src="./assets/img/lekkerland-logo.png" />
    </a>
  </div>

  <div class="navigation">
    @if (isAuthorized(); as user) {
      <ui-icon faName="door-open" faStyle="light" role="button" title="Abmelden" (click)="logout()"></ui-icon>
    } @else {
      <ui-icon faName="user" faStyle="light" role="button" title="Anmelden" (click)="login()"></ui-icon>
    }
  </div>
</header>
